import { render, staticRenderFns } from "./DashboardCard.vue?vue&type=template&id=9ccd9360&scoped=true&"
import script from "./DashboardCard.vue?vue&type=script&lang=ts&"
export * from "./DashboardCard.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardCard.vue?vue&type=style&index=0&id=9ccd9360&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccd9360",
  null
  
)

export default component.exports